import React from "react";

import { AuthContext } from "./AuthContext";

function withAuth(Component: React.ComponentType<any>) {
    const W = (props: any) => {
        return (
            <AuthContext.Consumer>
                {ctx => <Component authContext={ctx} {...props} />}
            </AuthContext.Consumer>
        );
    };

    (W as any).displayName = `withAuth(${Component.displayName || Component.name})`;

    return W;
}

export default withAuth;
